<template>
    <v-list two-line>
      <template v-for="(project, idx) in projects">
        <div :key="'project' + idx">
        <v-list-item @click="goToProject(project.link)" >
            <v-list-item-content>
              <v-list-item-title>{{ project.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ project.description }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        </div>
      </template>
    </v-list>
</template>

<script>
export default {
  name: 'projects',
  props: {
    latest: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      projects: this.latest ? this.$store.getters.latest : this.$store.getters.all,
    };
  },
  methods: {
    goToProject(link) {
      const win = window.open(link, '_blank');
      win.focus();
    },
  },
};
</script>
